var _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _circle2, _rect2, _path10, _path11, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle4, _path27, _path28, _path29, _path30, _rect3, _path31, _path32, _circle5, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_posting_photo_re_plk8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 643.755,
    height: 322.249,
    viewBox: "0 0 643.755 322.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15996",
    "data-name": "Path 15996",
    d: "M500,682.071h-1.2v-32.9a19.04,19.04,0,0,0-19.04-19.04h-69.7a19.04,19.04,0,0,0-19.04,19.04V829.649a19.04,19.04,0,0,0,19.04,19.04h69.7a19.04,19.04,0,0,0,19.04-19.04V705.488H500Z",
    transform: "translate(-329.616 -528.33)",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15997",
    "data-name": "Path 15997",
    d: "M488.28,642.4h-9.1a6.755,6.755,0,0,1-6.254,9.307H433a6.755,6.755,0,0,1-6.254-9.307h-8.5a14.219,14.219,0,0,0-14.219,14.219v180.21a14.219,14.219,0,0,0,14.219,14.219H488.28A14.219,14.219,0,0,0,502.5,836.829h0V656.619A14.219,14.219,0,0,0,488.281,642.4Z",
    transform: "translate(-337.372 -535.643)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2032",
    "data-name": "Rectangle 2032",
    width: 63.032,
    height: 42.525,
    transform: "translate(85.927 182.559)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15998",
    "data-name": "Path 15998",
    d: "M514.675,872.531H451.208V829.572h63.467Zm-63.032-.435h62.6v-42.09h-62.6Z",
    transform: "translate(-365.499 -647.23)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15999",
    "data-name": "Path 15999",
    d: "M464.937,868.294h52.379V838.464H464.937Z",
    transform: "translate(-373.684 -652.532)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 5.25,
    cy: 5.25,
    r: 5.25,
    transform: "translate(101.412 193.979)",
    fill: "#318af5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16000",
    "data-name": "Path 16000",
    d: "M505.7,879.655H479.944a.529.529,0,0,1-.1-.008l12.18-21.1a.853.853,0,0,1,1.484,0l8.174,14.158.392.678Z",
    transform: "translate(-382.573 -664.248)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16001",
    "data-name": "Path 16001",
    d: "M291.919,523.165h-8.793l4.316-6.27.311-.452.155-.226.391.678Z",
    transform: "translate(-168.794 -307.759)",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16002",
    "data-name": "Path 16002",
    d: "M546.486,888.834H524.211l4.316-6.27.311-.452,5.625-8.171a1.138,1.138,0,0,1,1.689-.1,1.032,1.032,0,0,1,.081.1Z",
    transform: "translate(-409.022 -673.428)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16003",
    "data-name": "Path 16003",
    d: "M714.734,765.449H545.793a15.12,15.12,0,0,1-15.1-15.1v-245a15.12,15.12,0,0,1,15.1-15.1H714.734a15.12,15.12,0,0,1,15.1,15.1v245A15.12,15.12,0,0,1,714.734,765.449Z",
    transform: "translate(-412.884 -444.927)",
    fill: "#e5e5e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16004",
    "data-name": "Path 16004",
    d: "M730.018,770.04H560.481a4.661,4.661,0,0,1-4.656-4.656V518.758a4.661,4.661,0,0,1,4.656-4.656H730.018a4.661,4.661,0,0,1,4.656,4.656V765.384a4.661,4.661,0,0,1-4.656,4.656Z",
    transform: "translate(-427.87 -459.154)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 1.285,
    cy: 1.285,
    r: 1.285,
    transform: "translate(215.452 48.653)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2033",
    "data-name": "Rectangle 2033",
    width: 133.393,
    height: 89.993,
    transform: "translate(154.642 125.354)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16005",
    "data-name": "Path 16005",
    d: "M755.085,778.226H620.771V687.313H755.085Zm-133.393-.92H754.164V688.233H621.692Z",
    transform: "translate(-466.589 -562.419)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16006",
    "data-name": "Path 16006",
    d: "M649.825,769.258H760.674V706.131H649.825Z",
    transform: "translate(-483.911 -573.638)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 11.11,
    cy: 11.11,
    r: 11.11,
    transform: "translate(187.414 149.523)",
    fill: "#318af5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16007",
    "data-name": "Path 16007",
    d: "M736.087,793.3h-54.5a1.111,1.111,0,0,1-.2-.016l25.777-44.649a1.8,1.8,0,0,1,3.142,0L727.6,778.6l.829,1.434Z",
    transform: "translate(-502.724 -598.432)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16008",
    "data-name": "Path 16008",
    d: "M550.418,460.859H531.81l9.134-13.268.658-.956.328-.478.828,1.434Z",
    transform: "translate(-317.055 -265.99)",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16009",
    "data-name": "Path 16009",
    d: "M822.4,812.726h-47.14l9.135-13.268.657-.956,11.9-17.291a2.409,2.409,0,0,1,3.575-.214,2.136,2.136,0,0,1,.171.214Z",
    transform: "translate(-558.695 -617.857)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16010",
    "data-name": "Path 16010",
    d: "M1243.02,1095.946l-8.552-3.6-5.866-42.869h-78.12l-6.359,42.694-7.651,3.825a1.817,1.817,0,0,0,.813,3.442h105.03a1.817,1.817,0,0,0,.7-3.491Z",
    transform: "translate(-773.441 -778.333)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16011",
    "data-name": "Path 16011",
    d: "M1167.84,972.484H784.09a7.6,7.6,0,0,1-7.586-7.6V910.768h398.92v54.114a7.6,7.6,0,0,1-7.583,7.6Z",
    transform: "translate(-559.434 -695.638)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16012",
    "data-name": "Path 16012",
    d: "M1175.307,618.737H775.635V387.2a9.176,9.176,0,0,1,9.165-9.165h381.341a9.176,9.176,0,0,1,9.165,9.165Z",
    transform: "translate(-558.916 -378.031)",
    fill: "#e5e5e5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16013",
    "data-name": "Path 16013",
    d: "M1176.247,626.741H824.317a7.074,7.074,0,0,1-7.066-7.066V426.712a7.074,7.074,0,0,1,7.066-7.066h351.93a7.074,7.074,0,0,1,7.066,7.066V619.676a7.074,7.074,0,0,1-7.066,7.066Z",
    transform: "translate(-583.727 -402.841)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16014",
    "data-name": "Path 16014",
    d: "M881.822,1173.389H239.894a.918.918,0,0,1-.9-.664.9.9,0,0,1,.866-1.125H881.749a.947.947,0,0,1,.947.7.9.9,0,0,1-.874,1.089Z",
    transform: "translate(-238.963 -851.14)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16015",
    "data-name": "Path 16015",
    d: "M1475.475,568.582c1.807-5.757,5.915-11.038,11.6-12.984s15.594-.127,18.273,5.276c3.861,7.786,2.127,17.322.079,25.776-1.068-.057-2.145-.1-3.226-.141l-1.529-5.1v5.045c-8.435-.261-17.216-.1-26,.071C1473.879,580.543,1473.669,574.339,1475.475,568.582Z",
    transform: "translate(-975.318 -483.441)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16016",
    "data-name": "Path 16016",
    d: "M1398.106,713.708l-7.1,2.973-14.846-25.953,10.473-4.389Z",
    transform: "translate(-820.442 -409.182)",
    fill: "#9f616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16017",
    "data-name": "Path 16017",
    d: "M1646.013,1133.723l-22.879,9.588-.121-.289a9.656,9.656,0,0,1,5.173-12.637h0l13.974-5.856Z",
    transform: "translate(-1063.657 -823.078)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16018",
    "data-name": "Path 16018",
    d: "M1410.386,748.988a5.323,5.323,0,0,1,2.16-7.871L1427.8,695.1l10.214,5.448-18.2,43.523a5.352,5.352,0,0,1-9.421,4.92Z",
    transform: "translate(-936.777 -567.06)",
    fill: "#9f616a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16019",
    "data-name": "Path 16019",
    d: "M1202.626,730.732h-7.693l-3.66-29.675h11.355Z",
    transform: "translate(-710.213 -417.957)",
    fill: "#9f616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16020",
    "data-name": "Path 16020",
    d: "M1426.583,1156.323h-24.807v-.314a9.656,9.656,0,0,1,9.655-9.655h15.152Z",
    transform: "translate(-932.209 -836.089)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16021",
    "data-name": "Path 16021",
    d: "M1248.42,351.429l1.743,4.532-.349,4.532-33.47-4.184,1.046-3.835,3.835-4.532Z",
    transform: "translate(-725.161 -207.436)",
    fill: "#9f616a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 12.185,
    cy: 12.185,
    r: 12.185,
    transform: "translate(500.287 78.835)",
    fill: "#9f616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16022",
    "data-name": "Path 16022",
    d: "M1457.5,646.941l6.973-4.184,13.946-1.395,12.326,2.789-.124,22.662-7.67,16.735-32.773-3.487-1.395-4.56s-9.065-12.175.7-19.148Z",
    transform: "translate(-957.953 -535.024)",
    fill: "#468af8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16023",
    "data-name": "Path 16023",
    d: "M1454.607,656.223l-1.743-1.046s-9.413,1.743-11.505,7.321-4.184,30.681-4.184,30.681l8.716,1.035,3.138-20.559Z",
    transform: "translate(-953.313 -543.26)",
    fill: "#5aa2fb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M1463.9,746.561V754.3s9.065,11.78,4.184,20.845c0,0,10.459,19.524,11.157,26.5l9.762,32.075s24.405,24.405,22.313,41.837l1.395,5.578-16.038,6.973-3.486-4.881L1466,836.511l-23.01-42.535-4.184,50.2s2.789,39.048-4.881,43.232l-.7,6.276h-16.276v-5.965s-6.037-21.229-2.55-37.267L1413,782.82s6.276-28.589,13.946-33.47l2.789-6.973Z",
    transform: "translate(-938.901 -595.247)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16025",
    "data-name": "Path 16025",
    d: "M1476.467,560.834a15.3,15.3,0,0,1,23.269,13.357c-6.811.313-13.966.395-21.221.409l-1.715-4.2-1.011,4.2q-3.316,0-6.645-.009A15.628,15.628,0,0,1,1476.467,560.834Z",
    transform: "translate(-972.367 -485.681)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2034",
    "data-name": "Rectangle 2034",
    width: 169.266,
    height: 114.195,
    transform: "translate(320.283 118.355) rotate(-14.268)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16026",
    "data-name": "Path 16026",
    d: "M1223.949,677.862l-165.177,42-28.432-111.8,165.177-42.005Zm-164.333,40.586,162.914-41.43-27.857-109.541L1031.76,608.906Z",
    transform: "translate(-710.766 -490.128)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16027",
    "data-name": "Path 16027",
    d: "M1091.7,710.587l136.32-34.667-19.742-77.633-136.319,34.666Z",
    transform: "translate(-735.577 -509.344)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 14.098,
    cy: 14.098,
    r: 14.098,
    transform: "translate(371.184 133.919)",
    fill: "#318af5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16028",
    "data-name": "Path 16028",
    d: "M1226.339,751.625l-67.026,17.045a1.406,1.406,0,0,1-.256.044l17.736-62.97a2.29,2.29,0,0,1,3.864-.982L1211.3,736.2l1.468,1.5Z",
    transform: "translate(-787.505 -572.4)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16029",
    "data-name": "Path 16029",
    d: "M1052.922,421.05l-22.884,5.82,7.084-19.174.51-1.381.255-.691,1.467,1.5Z",
    transform: "translate(-614.089 -241.825)",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16030",
    "data-name": "Path 16030",
    d: "M1332.5,750.225l-57.971,14.742,7.084-19.174.51-1.381,9.231-24.987a3.056,3.056,0,0,1,4.33-1.381,2.735,2.735,0,0,1,.278.209Z",
    transform: "translate(-856.345 -580.49)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16031",
    "data-name": "Path 16031",
    d: "M1500.563,759.006a5.5,5.5,0,0,1,.825.255l21.272-14.643-.487-6.255,9.344-1.968,1.938,10.989a4.166,4.166,0,0,1-2.26,4.46l-26.35,13a5.466,5.466,0,1,1-4.281-5.833Z",
    transform: "translate(-987.152 -591.681)",
    fill: "#9f616a"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16032",
    "data-name": "Path 16032",
    d: "M1545.959,648.6l5-1.046s11.033-3.835,11.73,10.111l1.395,32.773-10.358,1.395-4.285-28.589Z",
    transform: "translate(-1018.168 -538.429)",
    fill: "#5aa2fb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPlaceholder);
export default __webpack_public_path__ + "static/media/slider_placeholder.fa606e74e96846fc86cc0d0527018908.svg";
export { ForwardRef as ReactComponent };